import type { BodyRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type PostRatingBody = {
  content_object_id: string;
  rating: number;
};

export const postRating = async ({ body }: BodyRequest<PostRatingBody>) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  apiClient.post<any, ApiClientResponse<any>>(routes.evaluations.create, body);
